// extracted by mini-css-extract-plugin
module.exports = {"form":"form--12wSH","input":"input--34Lox","btn":"btn--1c4xK"};